import React, { Component } from "react";
import Navbar from "./Navbars";
import axios from "axios";
import ticket from "../ticketlogo.svg";
import Panel from "./bookfilterPanel";
import food from "../foodlogo.svg";
import dot from "../dot.jpg";
import Like from "./Like";
import { Redirect } from "react-router-dom";

let apiEndPoint =
  "https://us-central1-bkyow-22da6.cloudfunctions.net/app/movies/";
class Book extends Component {
  state = {
    dateindex: 0,
    datearr: "",
    price: ["0-100", "101-200", "201-300", "More than 300"],
    show: ["Morning", "Afternoon", "Evening", "Night"],
  };

  async componentDidMount() {
    let region = this.props.match.params ? this.props.match.params.region : "";
    let ind = this.props.match.params ? this.props.match.params.id : "";
    let { data: resp } = await axios.get(apiEndPoint + region + "/" + ind);
    if (resp) this.setState({ vl: resp, region, ind });
  }

  cbStructure(arr, value) {
    let temp = arr.map((vl) => ({
      name: vl,
      value: "",
    }));
    let val = value.split(",");
    for (let i = 0; i < arr.length; i++) {
      let obj = temp.find((vl) => vl.name === val[i]);
      if (obj) obj.value = true;
    }
    return temp;
  }
  handleDate = (ind, arr) => {
    this.setState({ dateindex: ind, datearr: arr });
  };
  handleFilter = (price, show) => {
    let pricefilt = price.filter((vl) => vl.value);
    let pricearr = pricefilt.map((vl) => vl.name);
    let pricestr = pricearr.join(",");
    let showfilt = show.filter((vl) => vl.value);
    let showarr = showfilt.map((vl) => vl.name);
    let showstr = showarr.join(",");
    this.setState({ pricestr, showstr });
  };
  handleLike = (val, inds) => {
    const movies = [...this.state.vl.showTiming[this.state.dateindex]];
    let { vl, dateindex } = this.state;

    movies[inds] = { ...movies[inds] };

    movies[inds].liked = !movies[inds].liked;
    console.log(vl.showTiming[dateindex]);
    vl.showTiming[dateindex] = movies;
    this.setState({ vl });
  };
  handleSub = (data) => {
    let region = this.props.location.state.region;
    this.props.history.push({
      pathname: "/movies/" + region,
      search: "?q=" + data,
    });
  };
  handleTiming = (data, timeind, rowind, dateindex, val) => {
    let region = this.props.match ? this.props.match.params.region : "";
    let id = this.props.match ? this.props.match.params.id : "";
    let { datearr, vl } = this.state;
    let current = new Date().getDate() + " Today";
    let value = datearr ? datearr[dateindex] : current;
    this.props.history.push({
      pathname:
        "/bookMovie/" +
        region +
        "/" +
        id +
        "/buyticket/" +
        rowind +
        "/" +
        timeind +
        "/" +
        dateindex,

      search: "?time=" + value,
      state: { data, vl, val },
    });
  };
  filterarr(price, show) {
    let { index, vl } = this.state;
    let pricearr = price.split(",");
    let cpyarr = [...(vl ? vl.showTiming : "")];
    console.log("cpy", cpyarr);
    if (cpyarr) {
      cpyarr = cpyarr[index].filter((vl) =>
        pricearr.map((val) =>
          val === "0-100"
            ? vl.timings.find((v) => v.price > 0 && v.price < 100)
              ? vl
              : ""
            : val === "101-200"
            ? vl.timings.find((v) => v.price > 101 && v.price < 200)
              ? vl
              : ""
            : vl.timings.find((v) => v.price > 201 && v.price < 300)
            ? vl
            : ""
        )
      );
    }
    console.log("cpy", cpyarr);
  }
  render() {
    let { vl, dateindex, price, show, pricestr, showstr, region } = this.state;
    let genre = vl ? vl.genre.split(",") : "";
    let priceopt = this.cbStructure(price, pricestr ? pricestr : "");
    let showopt = this.cbStructure(show, showstr ? showstr : "");

    console.log(region);
    return (
      <div className="container-fluid">
        <Navbar
          onSubmit={this.handleNavSearch}
          value={region}
          onSubmit={this.handleSub}
        />
        <nav className="navbar navbar-light bg-secondary p-3">
          <div className="navbar-brand mb-0 h1 text-white">
            <h3 className="row ml-4">{vl ? vl.title : ""}</h3>
            <i className="fa fa-heart text-danger m-2" aria-hidden="true">
              {" "}
            </i>
            <span className="text-white m-1">{vl ? vl.rating : ""}</span>
            {genre
              ? genre.map((vl) => (
                  <span
                    className="m-2"
                    style={{
                      border: "ridge",
                      fontSize: "14px",
                      borderSpacing: "50px 180px",
                      borderColor: "lightgray",
                      borderRadius: "12px",
                      color: "lightgray",
                    }}
                  >
                    {vl}
                  </span>
                ))
              : ""}
            <br />
            <span className=" row lead ml-4" style={{ fontSize: "12px" }}>
              {vl ? vl.votes : ""}:Votes
            </span>
          </div>
        </nav>
        <Panel
          ind={dateindex}
          onPress={this.handleDate}
          price={priceopt}
          show={showopt}
          onFilter={this.handleFilter}
        />
        <div className="row">
          <div className="ml-3 col-9">
            <div className="row " style={{ backgroundColor: "#FFE4C4" }}>
              <div className="col-6 border border-white">
                <div className="row">
                  <img src={ticket}></img>
                  <div className="col-12"></div>
                  <span style={{ fontSize: "12px" }}>M-Ticket Available</span>
                </div>
              </div>
              <div className="col-6">
                <div className="row">
                  <img src={food}></img>
                  <div className="col-12"></div>
                  <span style={{ fontSize: "12px" }}>Food Available</span>
                </div>
              </div>
            </div>
            <br />
            {vl
              ? vl.showTiming[dateindex].map((val, ind) => (
                  <div className="row">
                    <Like
                      liked={val.liked ? val.liked : ""}
                      onClick={() => this.handleLike(vl, ind)}
                    />

                    <div
                      className="col-sm-11 col-lg-4 font-weight-bold"
                      style={{ fontSize: "13px" }}
                    >
                      {val.name}
                      <br />
                      <span className="m-2">
                        <img src={ticket} style={{ height: "25px" }}></img>
                        <span className="lead" style={{ fontSize: "10px" }}>
                          <span> M-Ticket Available</span>
                        </span>
                      </span>{" "}
                      <span className="m-2">
                        <img src={food} style={{ height: "25px" }}></img>
                        <span className="lead" style={{ fontSize: "10px" }}>
                          F&B
                        </span>
                      </span>{" "}
                    </div>
                    <div className="col-sm-12 col-lg-7">
                      {val.timings.map((v, index) => (
                        <button
                          className="btn btn-outline-secondary m-1 btn-sm text-primary text-center"
                          data-toggle="tooltip"
                          style={{ fontSize: "14px" }}
                          title={v.price}
                          onClick={() =>
                            this.handleTiming(v, index, ind, dateindex, val)
                          }
                        >
                          {v.name}
                        </button>
                      ))}
                      <br />
                      <span style={{ fontSize: "12px" }} className="row ml-5">
                        <img
                          src={dot}
                          style={{ height: "30px" }}
                          className="ml-5"
                        ></img>
                        <span>Cancellation available</span>
                      </span>
                    </div>
                  </div>
                ))
              : ""}
          </div>
          <div className="d-sm-none d-md-block col-2">
            <img src="https://i.ibb.co/JqbbCJz/1331654202504679967.jpg"></img>
          </div>
        </div>
      </div>
    );
  }
}

export default Book;
